import React, { useMemo } from 'react';
import { getPrefixCls } from "../../utils/common";
import { Popup } from "../Popup";
import OrderPayType from "./components/order-pay-type";
import "./style.less";
import commonPool from "../../store/commonPool";
import { hiddenAlipay } from "../../service/activityService";
var prefixCls = getPrefixCls('SmPayment');
export var Payment = function Payment(props) {
  var _activityDetail$chann;
  var visible = props.visible,
    setVisible = props.setVisible,
    payType = props.payType,
    setPayType = props.setPayType,
    children = props.children,
    productInfo = props.productInfo,
    _props$isDev = props.isDev,
    isDev = _props$isDev === void 0 ? false : _props$isDev,
    initEvent = props.initEvent;
  var _ref = productInfo || {},
    singleProduct = _ref.product,
    activityDetail = _ref.activity,
    products = _ref.products,
    hasBuy = _ref.hasBuy,
    disabled = _ref.hasDisabled,
    isTrial = _ref.isTrial;
  var product = useMemo(function () {
    return singleProduct || (products && (activityDetail.channelDeliveryGroupId || products.length === 1) ? products[0] : null) || (isTrial ? products[0] : null) || commonPool.getSelectedProduct();
  }, [singleProduct, activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.channelDeliveryGroupId, products, isTrial, commonPool.getSelectedProduct()]);
  var channelId = activityDetail === null || activityDetail === void 0 ? void 0 : (_activityDetail$chann = activityDetail.channelDeliveryVersion) === null || _activityDetail$chann === void 0 ? void 0 : _activityDetail$chann.channelId;
  var projectId = activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.projectId;
  var isHiddenAlipay = hiddenAlipay(channelId, projectId);
  return /*#__PURE__*/React.createElement(Popup, {
    visible: visible && !!(product !== null && product !== void 0 && product.activityId) && (product === null || product === void 0 ? void 0 : product.price) > 0 && !hasBuy || visible && isDev,
    onMaskClick: function onMaskClick() {
      initEvent === null || initEvent === void 0 ? void 0 : initEvent();
      setVisible(false);
    },
    style: {
      zIndex: 999
    },
    getContainer: function getContainer() {
      return document.querySelector('.dnd-container') || document.body;
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-product-pay")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-product-pay-hd")
  }, "\u652F\u4ED8\u65B9\u5F0F"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OrderPayType, {
    hiddenAlipay: isHiddenAlipay,
    paytype: payType,
    onChange: function onChange(val) {
      return setPayType(val);
    },
    showFQ: (product === null || product === void 0 ? void 0 : product.price) >= 2000
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container")
  }, children)));
};